import React from 'react';
import { CContainer } from '@coreui/react';

interface IProps {
    children?: React.ReactNode;
}

export const AppContent: React.FC<IProps> = ({ children }) => {
    return <CContainer>{children}</CContainer>;
};
